import { useLayoutEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'
import { debounce } from 'remeda'
import { trackEvent } from '@velasca/utils/track-event'

/**
 * This middleware component is based on the official documentation by Algolia:
 * https://www.algolia.com/doc/guides/building-search-ui/going-further/integrate-google-analytics/react/.
 */

const trackingMiddleware = () => {
  const EventDebouncer = debounce(
    () => {
      trackEvent({
        googleAnalytics: {
          eventName: 'page_view',
          data: {
            page_location: window.location.pathname + window.location.search,
          },
        },
      })
    },
    { waitMs: 1500 },
  )

  return {
    onStateChange() {
      EventDebouncer.call()
    },
    subscribe() {},
    unsubscribe() {},
  }
}

export const AnalyticsMiddleware = () => {
  const { addMiddlewares } = useInstantSearch()

  useLayoutEffect(() => addMiddlewares(trackingMiddleware), [addMiddlewares])

  return null
}
